$(->
  toggle_onoff_btn = (btn, cb, hidden, on_off) ->
    if cb.is(':checked')
      cb.removeAttr('checked')
      cb.val(0)
      hidden.removeAttr('disabled') if hidden.attr('disabled')
    else
      cb.attr('checked', 'checked')
      cb.val(1)
      hidden.attr('disabled', 'disabled')

    current = on_off.text()
    result = if current == 'On'
              'Off'
            else
              'On'
    on_off.text(result)
    btn.removeClass(current.toLowerCase())
    btn.addClass(result.toLowerCase())

  toggle_options = (btn) ->
    opts = btn.siblings('.notif-opts')
    opts.each ->
      opt = $(this)
      if opt.hasClass('disabled')
        opt.removeClass('disabled')
        opt.attr('title', '')
        opt.attr('data-original-title', '')
      else
        opt.addClass('disabled')
        opt.attr('title', 'Turn notifications on to configure options.')
        opt.attr('data-original-title', 'Turn notifications on to configure options.')
      inputs = opt.find('select, input[type=checkbox], input[type=text], input.sms-first-enabled')
      inputs.each ->
        if $(this).hasClass('disabled')
          $(this).removeClass('disabled')
        else
          $(this).addClass('disabled')

  $(document).on 'click', '.cb-button', () ->
    btn_div = $(this)
    if btn_div.parent().hasClass('cb-button-wrap')
      btn_div = btn_div.parent()
    toggle_onoff_btn(
      $(this),
      btn_div.find('input[type=checkbox]'),
      btn_div.find('input[type=hidden]'),
      btn_div.find('.on-off')
    )
    toggle_options(btn_div)

  turn_off_hidden_btn = (btn) ->
    if btn.find('input[type=checkbox]').is(':checked')
      btn.find('input[type=hidden]').attr('disabled', 'disabled')

  disable_phone_input = (btn) ->
    return unless btn.hasClass('sms-button')
    phone_input = btn.siblings('.ft-phone').find('input.form-control, input.sms-first-enabled')
    if btn.find('input[type=checkbox]').is(':checked')
      sms_checkbox = btn.siblings('.ft-notif-type').find('input.sms-input')
      unless sms_checkbox.is(':checked')
        phone_input.attr('disabled', 'disabled')
    else
      phone_input.attr('disabled', 'disabled')

  $('body.manage.settings.employees form').submit ->
    phone = $('.ft-phone input')
    sms = $('input.sms-input')
    $('.cb-button').each ->
      turn_off_hidden_btn($(this))
      disable_phone_input($(this))

  $('body.manage.jobs form').submit ->
    users = $('.notifications-container')
    users.each ->
      $(this).find('.cb-button').each ->
        turn_off_hidden_btn($(this))
        disable_phone_input($(this))

  $(document).on 'change', '#notif-choose-user', () ->
    selected = parseInt($(this).val())
    close_btn = $('.notif-close-panel')
    if selected != ""
      close_btn.show()
    else
      close_btn.hide()
    $(".notification-wrapper.collapse").each ->
      nc = $(this)
      if nc.data('user-id') == selected
        nc.collapse('show')
      else
        nc.collapse('hide')

  $(document).on 'click', '.notif-close-panel', (e)->
    e.preventDefault()
    $(this).hide()
    $('#notif-choose-user').children().each ->
      if $(this).hasClass('notif-none')
        $(this).attr('selected')
      else
        $(this).removeAttr('selected')
    $(".notification-wrapper.collapse").each ->
      if $(this).is(':visible')
        $(this).collapse('hide')
        return

  $(document).on 'click', '.notif-ccs-link', (e)->
    e.preventDefault()
    ip = $('#job_notification_cc_input')
    if ip.hasClass('is-hidden')
      ip.removeClass('is-hidden')
    else
      ip.addClass('is-hidden')

)
